import { useEffect, useState } from "react";
import { Heart, MessageCircle, Send, Music2 } from "lucide-react";

// Looping muted "reel" — cycles creator frames with ken-burns + reel UI.
// (Image montage stands in for real MP4 loops; swap `images` for <video> later.)
export function ReelPhone({ images = [], caption = "সিলেটের গল্প", handle = "@madeinsylhet", className = "", interval = 2800 }) {
  const [i, setI] = useState(0);

  useEffect(() => {
    if (images.length < 2) return;
    const t = setInterval(() => setI((p) => (p + 1) % images.length), interval);
    return () => clearInterval(t);
  }, [images.length, interval]);

  return (
    <div className={`relative ${className}`}>
      <div className="relative rounded-[2.4rem] border-[7px] border-zinc-900 bg-black overflow-hidden shadow-2xl aspect-[9/16] ring-1 ring-white/10">
        {images.map((src, idx) => (
          <img
            key={idx}
            src={src}
            alt=""
            loading={idx === 0 ? "eager" : "lazy"}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${idx === i ? "opacity-100 ken-burns" : "opacity-0"}`}
          />
        ))}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/40 pointer-events-none" />

        {/* progress bars */}
        <div className="absolute top-3 inset-x-3 flex gap-1">
          {images.map((_, idx) => (
            <div key={idx} className="h-[3px] flex-1 rounded-full bg-white/25 overflow-hidden">
              <div
                className="h-full bg-white origin-left"
                style={{
                  animation: idx === i ? `reelProgress ${interval}ms linear` : undefined,
                  transform: idx < i ? "scaleX(1)" : idx > i ? "scaleX(0)" : undefined,
                }}
              />
            </div>
          ))}
        </div>

        {/* side actions */}
        <div className="absolute right-3 bottom-24 flex flex-col items-center gap-5 text-white">
          <div className="flex flex-col items-center"><Heart size={26} className="fill-sylhet-red text-sylhet-red" /><span className="text-[10px] mt-0.5">12.4k</span></div>
          <div className="flex flex-col items-center"><MessageCircle size={26} /><span className="text-[10px] mt-0.5">842</span></div>
          <div className="flex flex-col items-center"><Send size={26} /><span className="text-[10px] mt-0.5">Share</span></div>
        </div>

        {/* caption */}
        <div className="absolute left-3 bottom-4 right-16 text-white">
          <p className="font-bold text-sm">{handle}</p>
          <p className="font-bn text-sm text-white/85 leading-snug mt-0.5">{caption} <span className="text-sylhet-gold">#madeinsylhet #fahimalchoudhury</span></p>
          <p className="flex items-center gap-1.5 text-xs text-white/70 mt-1.5"><Music2 size={12} /> original sound — Made in Sylhet</p>
        </div>
      </div>
    </div>
  );
}
